import { jsx as _jsx } from "react/jsx-runtime";
/**
 * <TileMapLayer> renders the layer's placed cells (decoded at parse time) as its rendering
 * quadrants, each a lit canvas item of batched textured quads. The TileSet resolves from the
 * scene's SubResources. An unresolvable TileSet or undecodable tile data degrades to the
 * transform-only group with children intact (ADR-0008).
 */
import { useMemo } from 'react';
import { CanvasItem2D } from '../../../../r3f/components/CanvasItem2D';
import { layerQuadrants } from '../../../../resources/tileset/renderingQuadrants';
import { TileQuadrants } from '../../../../r3f/TileQuadrants';
import { useTileSetModel } from '../../../../r3f/useTileSetModel';
import { useNode2DTextureSampler } from '../../../../r3f/canvasItemTextureSampler';
export function TileMapLayer({ node, children }) {
    const props = node.properties;
    const { model, status } = useTileSetModel(props.tile_set);
    const sampler = useNode2DTextureSampler(props);
    const cells = props.cells ?? null;
    const { y_sort_enabled: ySortEnabled, y_sort_origin: ySortOrigin, rendering_quadrant_size: quadrantSize, } = props;
    // Parsed cells never change identity, so the batched geometries survive
    // unrelated re-renders and rebuild only on new data.
    const quadrants = useMemo(() => model && cells?.length
        ? layerQuadrants(cells, model, { ySortEnabled, ySortOrigin, quadrantSize })
        : null, [model, cells, ySortEnabled, ySortOrigin, quadrantSize]);
    return (_jsx(CanvasItem2D, { node: node, props: props, ownItems: (tint, material, zFinal) => props.enabled && status === 'loaded' && model && quadrants ? (_jsx(TileQuadrants, { quadrants: quadrants, model: model, selfTint: tint.self, material: material, lightMask: props.light_mask, zFinal: zFinal, name: node.name, sampler: sampler })) : null, children: children }));
}
//# sourceMappingURL=Component.js.map